import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1867c0',
        secondary: '#dd0b7e',
        background: "#f6f7fb",
        text: "#251433",
        menu: "#ffffff",
        menuhover: "#f6f7fb",
        menuborder: "#e8e9ee"
      },
      dark: {
        primary: '#1867c0',
        secondary: '#ffffff',
        background: "#000000",
        text: "#f9f9f9",
        menu: "#292929",
        menuhover: "#3a3a3a",
        menuborder: "#434343"
      },
    },
  },
})
